/**
 * Client-side gate for the Faculty Diary portability UI (ACR-05).
 * Mirrors backend DIARY_PORTABILITY_ENABLED / DIARY_TRANSFER_ENABLED — fail closed.
 *
 * This hides navigation; it does not authorize anything. The server gates the
 * routes and answers 404 when the feature is off, so a user who reaches the page
 * by URL with the flag on but without TRANSFER_DIARY_OWNERSHIP still gets 403
 * from the API. The client never decides permission.
 */

function parseEnvFlag(value) {
  return String(value || 'false').trim().toLowerCase() === 'true';
}

/**
 * @returns {boolean}
 */
export function isDiaryTransferUiEnabled() {
  return (
    parseEnvFlag(process.env.REACT_APP_DIARY_PORTABILITY_ENABLED) &&
    parseEnvFlag(process.env.REACT_APP_DIARY_TRANSFER_ENABLED)
  );
}

/** Faculty workbook export/import (Epic B). */
export function isDiaryWorkbookUiEnabled() {
  return (
    parseEnvFlag(process.env.REACT_APP_DIARY_PORTABILITY_ENABLED) &&
    parseEnvFlag(process.env.REACT_APP_DIARY_WORKBOOK_ENABLED)
  );
}
